<template lang="pug">
.d-flex.flex-column.full-height
  .container.grid-md.p-relative.flex-1.flex-centered
    .glass.card.my-2
      .card-body.flex-centered.flex-column
        .d-flex.justify-content-around
          .logo-container.my-2
            img.app-logo.img-responsive(
              alt="App logo",
              src="@/assets/logo.png"
            )
        .h3.mt-2 Acesso Cidadão
        .version.text-small v{{ version }}
        p.text.pt-2.text-center O Acesso Cidadão tem como principal objetivo facilitar a vida do cidadão, oferecendo serviços que podem ser acessados a qualquer momento de maneira fácil e rápida, prezando sempre pela transparência e confiabilidade.
        router-link.btn.btn-primary.btn-lg(:to="{ name: 'app.home' }") Fazer login
      .flex-centered
        img.img-responsive.image-qr.my-2(
          alt="Qr code para baixar o aplicativo",
          src="@/assets/qr-code.png"
        )
      .mobile-app.m-2
        .flex-centered
          a.mx-2.c-hand.tooltip(
            data-tooltip="Google Play",
            href="https://play.google.com/store/apps/details?id=com.paliari.cidadaomga",
            target="_blank"
          )
            img(src="@/assets/google-play.png")
          a.mx-2.c-hand.tooltip(
            data-tooltip="App Store",
            href="https://apps.apple.com/br/app/cidadao-maringa/id932510005",
            target="_blank"
          )
            img(src="@/assets/app-store.png")
        .text.text-center Disponível também para Android e iOS
        .text-center
          verificar-doc(button-class="btn btn-link mt-2 btn-sm")
  footer-app
</template>

<script>
import { version } from "../../package";
import FooterApp from "@/components/Footer";

export default {
  components: { FooterApp },
  computed: {
    version() {
      return version;
    },
  },
  created() {
    if (this.$auth.getToken()) {
      this.$router.replace({ name: "app.home" });
    }
  },
};
</script>

<style lang="stylus" scoped>
.full-height {
  height: 100vh;
}

.app-logo {
  width: 100px;
}

.d-flex.justify-content-around {
  width: 50%;
  flex-wrap: wrap;
}

.paliari-logo {
  max-width: 30px;
}

.logo-container {
  background-color: white;
  border-radius: 50%;
  padding: 10px;
  display: inline-block;
}

.divider {
  width: 100%;
  border-color: rgba(255, 255, 255, 0.1);
}

.card {
  .card-body {
    padding: 2rem;
  }

  .image-qr {
    width: 150px;
  }

  .card-footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    flex-wrap: wrap;
  }
}
</style>